import { Component, OnInit } from '@angular/core';
import { PageBase } from '../../base/page-base/page-base.component';

@Component({
    templateUrl: 'not-found.page.html',
    selector: 'not-found-page',
    standalone: false,
})
export class NotFoundPage extends PageBase implements OnInit {
    //TODO LATER: implement more from these: https://freefrontend.com/html-css-404-page-templates/
    public headerText: string;

    public ngOnInit(): void {
        this.headerText = this.settings.applicationShortNameWithVersion;
    }
}
